import {
    useState,
    useMemo,
    useEffect,
    useCallback
} from 'react';
import {
    Container,
    Content,
    Header,
    NumberComments,
    Card,
    AddComments,
    ViewComments,
    DetailsComment,
    NewComment,
    Separator,
    SelectCategory,
    Options,
    Option,
    BtnSave,
    Actions,
    MessageAlert
} from './styled';
import { Avatar, Modal, Alert } from '../../components';
import { IoIosAdd } from 'react-icons/io';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import { format } from 'date-fns';
import { api } from '../../service/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/auth';

export function Comments(props) {
    const {
        client,
        idUser,
        allowCreation,
        setCommentsNotification
    } = props;

    const { isAdm } = useAuth();
    const [renderModal, setRenderModal] = useState(0);
    const [comments, setComments] = useState([]);
    const [categories, setCategories] = useState([]);
    const [commentSelected, setCommentSelected] = useState(false);
    const [disableCommentMsg, setDisableCommentMsg] = useState(false);

    const searchComments = useCallback(async (clientNumber) => {
        const { data } = await api.get(`/comments?client_number=${clientNumber}`);
        onCommentsNotification(data);
        onSeparateByCategories(data);
    }, []);
    const searchCategories = useCallback(async () => {
        const { data } = await api.get(`/categories`);
        setCategories(data);
    }, []);
    useEffect(() => {
        searchComments(client?.number);
    }, [client?.number, searchComments]);


    function onSeparateByCategories(allComments) {
        const objectsByCategory = [];
        allComments.forEach(comment => {
            const index = objectsByCategory.findIndex(
                item => item[0].category_id === comment.category_id
            );
            index === -1
                ? objectsByCategory.push([comment])
                : objectsByCategory[index].push(comment)
        });
        setComments(objectsByCategory);
    };
    function onCommentsNotification(allComments) {
        if (allComments?.length) {
            setCommentsNotification(
                {
                    cont: allComments?.length,
                    colorPriority: allComments[0].color_rgb
                }
            )
        }
    };

    function handleNewComment() {
        searchCategories();
        setRenderModal(1);
    };
    function handleDetailsComment(details) {
        setCommentSelected(details);
        setRenderModal(2);
    };

    async function handleDelete(id) {
        const { status } = await api.delete(`/comments`, {
            data: { id: id } 
        });
        setDisableCommentMsg(false);
        if (status === 200) {
            searchComments(client?.number);
            setRenderModal(0);
        } else {
            toast.error('Erro ao excluir anotação!', { position: "top-center", theme: "colored" });
        }
        return
    };

    const RenderViewComments = ({ comment }) => {
        return (
            <ViewComments key={comment?.id}>
                <Card
                    className='viewComments--card'
                    color={comment?.color_rgb}
                    onClick={() => handleDetailsComment(comment)}
                >
                    <div className='description'>
                        <p>{comment?.text}</p>
                    </div>
                    <div className='info--comments'>
                        <p>
                            {`${format(new Date(comment?.dt_comment), "dd MMM yyyy")} | ${comment.name_usuario}`}
                        </p>
                    </div>
                </Card>
            </ViewComments>
        )
    };
    const RenderDetailsComment = () => {
        return (
            <DetailsComment>
                <div className='line-info'>
                    <Avatar
                        name={commentSelected?.name_usuario}
                        width={'45px'}
                        height={'45px'}
                        fontSize={'1.3rem'}
                    />
                    <div className='info'>
                        <span className='author'>
                            {commentSelected?.name_usuario}
                        </span>
                        {commentSelected &&
                            <span className='date'>
                                {`${format(new Date(commentSelected?.dt_comment), "dd MMM yyyy - hh:mm")}`}
                            </span>
                        }
                    </div>
                </div>
                <div className='line-card'>
                    <Card
                        className='card'
                        color={commentSelected?.color_rgb}
                    >
                        <div className='category'>
                            <div className='--name'>
                                <p className='filter--'>{commentSelected?.category_name}</p>
                            </div>
                        </div>
                        <div className='description'>
                            <p>{commentSelected?.text}</p>
                        </div>
                    </Card>
                </div>
                {(commentSelected?.id_usuario == idUser || isAdm) && (
                    <div>
                        <Actions>
                            <div onClick={() => setDisableCommentMsg(true)}>
                                <span className="dsUs">
                                    Excluir
                                </span>
                            </div>
                        </Actions>
                    </div>
                )}
            </DetailsComment>
        )
    };
    const RenderNewComment = () => {
        const [isOpenOptions, setIsOpenOptions] = useState(false);
        const [categorySelected, setSategorySelected] = useState(false);
        const [text, setText] = useState('');
        const [inLoading, setInLoading] = useState(false);


        async function handleSaveComment() {
            setInLoading(true);
            if (!text) {
                toast.warning('Por favor insira um texto !', { position: "top-center", theme: "colored" });
                setInLoading(false);
                return
            }
            if (!categorySelected) {
                toast.warning('Por favor selecione uma categoria !', { position: "top-center", theme: "colored" });
                setInLoading(false);
                return
            }
            const { status } = await api.post(`/comments`, {
                id_client: client?.id,
                text,
                category_id: categorySelected.id,
                id_usuario: idUser,
            })
            setInLoading(false)
            if (status === 201) {
                searchComments(client?.number);
                setRenderModal(0);
            } else {
                toast.error('Erro ao criar anotação !', { position: "top-center", theme: "colored" });
            }
            return
        }

        return (
            <NewComment inLoading={inLoading}>
                <div className='line-card'>
                    <Card
                        className='card'
                        color={categorySelected?.color_rgb}
                    >
                        <div className='category'>
                            <SelectCategory
                                color={categorySelected?.color_rgb}
                            >
                                <div className='preview' onClick={() => setIsOpenOptions(!isOpenOptions)}>
                                    <div className='ident'>
                                        {!categorySelected
                                            ? <> {`Categoria`} </>
                                            : <>{categorySelected.name}</>
                                        }
                                    </div>
                                    <span className='icon--action'>
                                        {!isOpenOptions ? <BiChevronDown /> : <BiChevronUp />}
                                    </span>
                                </div>
                                <Options isOpen={isOpenOptions}>
                                    {categories?.map((category) => {
                                        return (
                                            <Option
                                                onClick={() => {
                                                    setSategorySelected(category)
                                                    setIsOpenOptions(!isOpenOptions);
                                                }}
                                                key={category?.id}
                                                color={category?.color_rgb}
                                            >
                                                <span>
                                                    {category?.name}
                                                </span>
                                            </Option>
                                        )
                                    })}
                                </Options>
                            </SelectCategory>
                        </div>
                        <div className='description'>
                            <textarea
                                rows="30"
                                cols="50"
                                placeholder='Digite algo...'
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                            />
                        </div>
                    </Card>
                </div>
                <div className='--save'>
                    <BtnSave onClick={() => handleSaveComment()}>
                        Salvar
                    </BtnSave>
                </div>
            </NewComment>
        )
    };

    const SeparateByCategories = ({ category }) => {
        const [isOpen, setIsOpen] = useState(true);
        return (
            <Separator
                isOpen={isOpen ? true : false}
                color={category[0].color_rgb}
            >
                <div
                    className='identification'
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <span className='name--category'>
                        {`
                            ${category[0].category_name} 
                            -
                            ${category.length} 
                        `}
                    </span>
                    <span className='icon--action'>
                        {!isOpen ? <BiChevronDown /> : <BiChevronUp />}
                    </span>
                </div>
                <div className='content'>
                    {
                        category.map((comment) => {
                            return (
                                <RenderViewComments
                                    key={comment.id}
                                    comment={comment}
                                />
                            )
                        })
                    }
                </div>
            </Separator>
        )
    };
    const myStateElements = useMemo(() => comments?.map((category) => (
        <SeparateByCategories
            key={category[0].category_id}
            category={category}
        />
    )), [comments]);

    return (
        <>
            <Container>
                <Header>
                    <div className='card--number'>
                        {comments.map((categories) => {
                            return (
                                <NumberComments
                                    key={categories[0]?.id}
                                    color={categories[0]?.color_rgb}
                                >
                                    {categories?.length}
                                </NumberComments>
                            )
                        })}
                    </div>
                </Header>
                <Content>
                    {myStateElements}
                </Content>
                {allowCreation &&
                    <div className='creat-new-comments'>
                        <AddComments onClick={() => handleNewComment()}>
                            <IoIosAdd /> Nova Anotação
                        </AddComments>
                    </div>
                }
            </Container>
            <Modal
                title={`${renderModal === 1 ? 'Nova' : ''} Anotação`}
                isOpen={renderModal}
                close={() => setRenderModal(0)}
            >
                {renderModal === 1
                    ? <RenderNewComment />
                    : <RenderDetailsComment />
                }
            </Modal>
            {(disableCommentMsg) &&
                (<Alert
                    isOpen={true}
                    onClickOption1={
                        () => handleDelete(commentSelected.id)
                    }
                    onClickOption2={
                        () => setDisableCommentMsg(false)
                    }
                >
                    <MessageAlert>
                        <p>
                            {`Deseja excluir permanentemente a anotação?`}
                        </p>
                    </MessageAlert>
                </Alert>)
            }
        </>
    );
}

